import { cn } from "@/lib/utils";

const iconWrap = "h-[1em] w-[1em] shrink-0 opacity-100";

const linkCls =
  "inline-flex items-center gap-1.5 font-normal leading-none text-foreground/75 transition-colors hover:text-foreground";

/**
 * Tres enlaces en fila: icono + nombre. Spotify: onda más larga arriba, longitud decreciente; arcos hacia arriba.
 */
export const SocialExternalLinks = ({ className }: { className?: string }) => (
  <div className={cn("flex flex-wrap items-center gap-5", className)}>
    <a
      href="https://www.instagram.com/popistant_/"
      target="_blank"
      rel="noreferrer"
      className={linkCls}
    >
      <svg className={iconWrap} viewBox="0 0 24 24" fill="none" aria-hidden>
        <rect x="2.5" y="2.5" width="19" height="19" rx="5" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="17.25" cy="6.75" r="0.9" fill="currentColor" stroke="none" />
      </svg>
      <span>Instagram</span>
    </a>

    <a
      href="https://open.spotify.com/user/popistant"
      target="_blank"
      rel="noreferrer"
      className={linkCls}
    >
      <svg className={iconWrap} viewBox="0 0 24 24" fill="none" aria-hidden>
        <circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5" />
        {/* Misma forma cúbica en cada arco; reordenadas en Y: arriba la más ancha, abajo la más corta. */}
        <path
          d="M5.65 9.35c3.8-.85 8.45-.8 12.35.25M6.4 12c3.2-.75 7.2-.75 10.6.2M7.2 14.65c2.6-.65 5.8-.65 8.8.15"
          stroke="currentColor"
          strokeWidth="1.45"
          strokeLinecap="round"
        />
      </svg>
      <span>Spotify</span>
    </a>

    <a
      href="https://x.com/popistant"
      target="_blank"
      rel="noreferrer"
      className={cn(linkCls, "flex flex-row flex-nowrap")}
      dir="ltr"
    >
      <svg className={cn(iconWrap, "order-1 shrink-0")} viewBox="0 0 24 24" aria-hidden>
        <path
          fill="currentColor"
          d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
        />
      </svg>
      <span className="order-2 font-body text-[1em] font-normal tracking-normal text-foreground/75">
        X
      </span>
    </a>
  </div>
);
